import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import VehicleModelScreen from "../../../container/Vehicles/VehicleModelScreen";
import CreateVehicleModel from "../../../container/Vehicles/VehicleModelScreen/CreateVehicleModel";

const VehicleModelRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.VEHICLE_MODEL.HOME}
          element={<VehicleModelScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.VEHICLE_MODEL.CREATE}
          element={<CreateVehicleModel />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.VEHICLE_MODEL.EDIT}
          element={<CreateVehicleModel isEdit={true} />}
        />
      )}
    </>
  );
};

export default VehicleModelRoutes;
